
import get_vr_msg from './get_vr_msg'
import vr_tip from '../img_preview/mixin/vr_tip'
export default {
    mixins: [
        vr_tip,
        get_vr_msg
    ],
    computed: {
        show_720 () {
            const { vr_panorama_resource } = this.house
            return vr_panorama_resource && vr_panorama_resource.vr_panorama_url
        },
        cover_720 () {
            const { vr_panorama_resource } = this.house
            return vr_panorama_resource && vr_panorama_resource.cover_image_url ? vr_panorama_resource.cover_image_url : ''
        },
        show_vr () {
            const { vr_resource } = this.house
            return Boolean(vr_resource && vr_resource.vr_photo_url)
        },
        show_video () {
            return Boolean(this.video_url)
        },
        video_url () {
            const { video_resource } = this.house
            return video_resource && video_resource.video_url ? video_resource.video_url : ''
        }
    },
    methods: {
        goVR () {
            const { id, name, activities } = this.house
            if (activities && activities.length && activities.indexOf('vr') > -1) {
                this.getVr().then(res => {
                    if (res.items && res.items.length === 1) {
                        this.openVr(res.items[0].vr_link)
                    } else {
                        this.goSubPagePath(`/building/vr?building_id=${id}&title=${name}`)
                    }
                })
            }
        },
        goVideo () {
            const { id, name } = this.house
            wx.navigateTo({
                url: `/building/video?building_id=${id}&title=${name}&src=${this.video_url}`
            })
        },
        goPlanarGraph () {
            const { id } = this.house
            wx.navigateTo({
                url: `/building/planar_graph?building_id=${id}`
            })
        }
    }
}